export default function AIEvaluation() {
  const features = [
    {
      icon: 'ri-brain-line',
      title: 'Akıllı Analiz',
      description: 'Yapay zeka, çözdüğün soruları analiz ederek güçlü ve zayıf yönlerini belirler.',
      color: 'from-purple-500 to-pink-500'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Kişisel Öneriler',
      description: 'Eksik kazanımların için özel olarak seçilmiş sorular ve çalışma materyalleri.',
      color: 'from-teal-500 to-cyan-500'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'İlerleme Takibi',
      description: 'Gelişimini grafiklerle takip et. Hangi konularda ilerlediğini gör.',
      color: 'from-emerald-500 to-green-500'
    },
    {
      icon: 'ri-target-line',
      title: 'Hedef Odaklı',
      description: 'LGS hedefine ulaşmak için gereken adımları net bir şekilde gör.',
      color: 'from-orange-500 to-red-500'
    },
  ];

  return (
    <section id="ai-degerlendirme" className="py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-purple-100 rounded-full mb-6">
            <div className="w-2 h-2 bg-purple-500 rounded-full animate-pulse"></div>
            <span className="text-purple-700 text-sm font-semibold" style={{ fontFamily: 'Poppins, sans-serif' }}>
              YAPAY ZEKA DEĞERLENDİRME
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
            Yapay Zeka ile
            <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-pink-600">
              Kişiselleştirilmiş Eğitim
            </span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" style={{ fontFamily: 'Poppins, sans-serif' }}>
            Gelişmiş yapay zeka algoritmaları ile performansını analiz ediyor, eksiklerini tespit ediyor ve sana özel çalışma planı oluşturuyoruz
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Side - Image */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/97e87f9f755e68ec33a8e6007b67cc9b.jpg"
                alt="AI Değerlendirme"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-br from-purple-600/20 to-pink-600/20"></div>
            </div>

            {/* Floating Stats */}
            <div className="absolute -top-6 -right-6 bg-white rounded-2xl p-6 shadow-2xl">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-purple-500 to-pink-500 rounded-xl">
                  <i className="ri-robot-2-line text-2xl text-white"></i>
                </div>
                <div>
                  <div className="text-2xl font-bold text-gray-900" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                    %98
                  </div>
                  <div className="text-xs text-gray-600" style={{ fontFamily: 'Poppins, sans-serif' }}>
                    Doğruluk Oranı
                  </div>
                </div>
              </div>
            </div>

            <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl p-6 shadow-2xl">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-teal-500 to-emerald-500 rounded-xl">
                  <i className="ri-lightbulb-flash-line text-2xl text-white"></i>
                </div>
                <div>
                  <div className="text-2xl font-bold text-gray-900" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                    1250+
                  </div>
                  <div className="text-xs text-gray-600" style={{ fontFamily: 'Poppins, sans-serif' }}>
                    Özel Öneri
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side - Features */}
          <div className="space-y-6">
            {features.map((feature, index) => (
              <div
                key={index}
                className="group bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 cursor-pointer"
              >
                <div className="flex items-start gap-4">
                  <div className={`w-14 h-14 flex items-center justify-center rounded-2xl bg-gradient-to-br ${feature.color} flex-shrink-0 group-hover:scale-110 transition-transform duration-300`}>
                    <i className={`${feature.icon} text-3xl text-white`}></i>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-purple-600 transition-colors duration-300" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                      {feature.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed" style={{ fontFamily: 'Poppins, sans-serif' }}>
                      {feature.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}

            {/* CTA Box */}
            <div className="bg-gradient-to-br from-purple-600 to-pink-600 rounded-2xl p-8 text-white mt-8">
              <h3 className="text-2xl font-bold mb-3" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                Hemen Dene!
              </h3>
              <p className="text-purple-100 mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Yapay zeka destekli değerlendirme sistemimizi ücretsiz dene ve farkı hemen gör.
              </p>
              <button className="px-8 py-3 bg-white text-purple-600 rounded-xl font-bold hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Ücretsiz Başla
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
